module.exports = __webpack_public_path__ + "img/rubio-de-casas.bffa4c54.png";